<template>
  <div>
    <section id="employees">
      <b-field label="Tenute" v-if="isCoordinator || isManager">
        <b-select @change.native='getEmployees' v-model='selectedEstateId' icon="globe" icon-pack="fas"
                  placeholder="Seleziona la tenuta"
                  expanded>
          <option v-for="(estate, idx) in estates"
                  :value="estate.id"
                  :key="estate.id">{{ estate.name }}
          </option>
        </b-select>
      </b-field>
      <b-field label="Operai">
        <b-select v-model='selectedEmployeeId' placeholder="Seleziona il tuo nome"
                  icon="user" icon-pack="fas" expanded required>
          <option v-for="employee in employees"
                  :value="employee.id"
                  :key="employee.id">{{ employee.name }} {{ employee.lastname }}
          </option>
        </b-select>
      </b-field>
    </section>
    <section id="sign">
      <sign @signed="perform" @error="signError" :enableSignaturePad="enableSignaturePad"></sign>
    </section>
  </div>
</template>

<script>
  import {api, utils} from '../../helpers'
  import sign from '../actions/Sign'
  import BField from 'buefy/src/components/field/Field'
  import BSelect from 'buefy/src/components/select/Select'
  import {mapGetters, mapState} from 'vuex'

  export default {
    name: 'Presence',
    components: {BSelect, BField, sign},
    data: function () {
      return {
        enableSignaturePad: true,
        employees: [],
        estates: [],
        selectedEstateId: null,
        selectedEmployeeId: null
      }
    },
    computed: {
      ...mapGetters('auth', {
        isCoordinator: 'isCoordinator',
        isManager: 'isManager',
        isLeader: 'isLeader',
        isWorkman: 'isWorkman'
      }),
      ...mapState('auth', {
        estateIds: 'estateIds'
      })
    },
    methods: {
      getEmployees (event) {
        if (this.employees.length > 0) {
          this.employees.splice(0, this.employees.length)
        }
        const modal = this.$loading.open()
        const estateId = parseInt(event.target.value)
        this.callAvailableMembersAndLeaders(estateId)
        modal.close()
      },
      callAvailableMembersAndLeaders (estateId) {
        api.getAvailableMembers(estateId)
          .then(response => {
            if (typeof response !== 'undefined' && response.length > 0) {
              this.employees = response
            } else {
              utils.errors(['Non ci sono operai per questa tenuta'])
            }
          })
          /* TODO:
                    .then(() => {
                      api.getAvailableLeaders(estateId)
                        .then(response => {
                          if (typeof response !== 'undefined' && response.length > 0) {
                            this.employees = this.employees.concat(response)
                          } else {
                            utils.errors(['Non ci sono responsabili per questa tenuta'])
                          }
                        })
                    })
          */
          .catch(errors => utils.errors(errors))
      },
      signError (errorMessage) {
        utils.errors([errorMessage])
      },
      perform (dataURL) {
        if (this.selectedEmployeeId === null) {
          utils.errors(['Operaio non selezionato'])
          return false
        }
        utils.confirm('Vuoi inviare la tua firma?', () => {
          const modal = this.$loading.open()
          api.newSign(this.selectedEmployeeId, dataURL)
            .then(response => {
              let msg = `Firma accettata per ${response.name} ${response.lastname}`
              this.selectedEmployeeId = null
              utils.success(msg, modal)
              modal.close()
            })
            .catch(errors => utils.errors(errors, modal))
        })
      }
    },
    mounted () {
      if (this.isCoordinator || this.isManager) {
        api.getEstates()
          .then(response => {
            this.estates = response.filter(estate => {
              let item = this.estateIds.find(id => estate.id === id)
              return typeof item !== 'undefined'
            })
          }).catch(errors => utils.errors(errors))
      } else {
        if (this.estateIds.length === 0) {
          utils.errors(['Nessuna tenuta assegnata'])
        } else {
          this.callAvailableMembersAndLeaders(this.estateIds)
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  #sign {
    margin-top: 1em;
  }
</style>



// WEBPACK FOOTER //
// src/components/views/Presence.vue